/**
 * Character Customizer — asset URL resolution.
 * Item art lives on the CDN under `assets/character/<category>/<id>.webp`.
 */

import { Image } from 'expo-image';
import { getAssetUrl, IDLE_COIN_SOURCE } from '../../../constants/assets';

const CHARACTER_ASSET_PREFIX = 'assets/character';

/** Real, bundled coin image reused from the coin store (never depends on CDN reachability). */
export const COIN_IMAGE_SOURCE = IDLE_COIN_SOURCE;

/** Resolve an item's CDN URL from its catalog asset key (e.g. `hats/usa`). */
export function getCustomizerAssetUrl(assetKey: string): string {
  return getAssetUrl(`${CHARACTER_ASSET_PREFIX}/${assetKey}.webp`);
}

/** Best-effort prefetch into the expo-image memory/disk cache. */
export function prefetchCustomizerAssets(urls: readonly string[]): void {
  if (urls.length === 0) return;
  void Image.prefetch([...urls], { cachePolicy: 'memory-disk' }).catch(() => {
    // Best-effort; layers still load on demand.
  });
}
